const getters = {
    routes: state => state.router.routes,
    token: state => state.user.token,
    userInfo: state => state.user.info,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js